import React from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';

import { bibContextShape } from 'app/shapes/analytics';
import { ANALYTICS_CONTEXTS } from 'app/constants/AnalyticsConstants';

const SUPPORTED_CONTEXTS = values(ANALYTICS_CONTEXTS);

export default class AnalyticsContext extends React.PureComponent {
  constructor(props) {
    super(props);
    const { analyticsActions, context, contextName } = props;

    if (SUPPORTED_CONTEXTS.includes(contextName)) {
      analyticsActions.setContext(contextName, context);
    } else {
      throw new Error(`${contextName} is not a supported analytics context.`);
    }
  }

  componentDidUpdate() {
    const { context, contextName, analyticsActions } = this.props;
    analyticsActions.setContext(contextName, context);
  }

  componentWillUnmount() {
    const { contextName, analyticsActions } = this.props;
    analyticsActions.setContext(contextName, undefined);
  }

  render() {
    return null;
  }
}

AnalyticsContext.propTypes = {
  analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  context: bibContextShape.isRequired,
  contextName: PropTypes.oneOf(Object.values(ANALYTICS_CONTEXTS)).isRequired
};
